import React, { Component } from 'react';
import SelectRolePres from 'src/ui/features/Login/presentational/SelectRolePres';
import { sendSelectedUserRole } from 'src/services/login.service';
import { CONSENT_URL } from 'src/constants/constants';
import { getDashboardURL } from 'src/helpers/commonFunctions';

class SelectRoleContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
    };
  }

  selectRole = role => {
    sendSelectedUserRole({ selectedRole: role })
      .then(res => {
        if (res && !res.error) {
          this.setState({
            isOpen: false,
          });
          sessionStorage.setItem('userInfo', JSON.stringify(res.data.data));
          if (res.data.data.isConsentAcceptanceNeeded === true) {
            sessionStorage.setItem('CN', 'CN');
            window.location.replace(CONSENT_URL);
          } else {
            window.location.replace(getDashboardURL());
          }
        } else {
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  render() {
    return <SelectRolePres isOpen={this.state.isOpen} selectRole={this.selectRole} />;
  }
}

export default SelectRoleContainer;
